import { createSelector } from 'redux-orm';

import orm from '../orm';

export const channelsSelector = createSelector(orm, ({ Channel }) =>
  Channel.getOrderedQuerySet().toRefArray(),
);

export const itemsSelector = createSelector(orm, ({ Item }) => {
  const items = Item.getOrderedQuerySet().toModelArray();

  if (!items) {
    return items;
  }

  return items.map((item) => ({
    ...item.ref,
    deviceModel: item.deviceModel?.ref,
  }));
});

export const alertsSelector = createSelector(orm, ({ Alert }) => {
  const alerts = Alert.getOrderedQuerySet().toModelArray();

  if (!alerts) {
    return alerts;
  }

  return alerts.map((alert) => ({
    ...alert.ref,
    alertSetting: alert.alertSetting?.ref,
    device: alert.device?.ref,
    item: alert.item?.ref,
    line: alert.line?.ref,
    site: alert.site?.ref,
  }));
});

export const alertsOccurSelector = createSelector(orm, ({ AlertOccur }) => {
  const alertOccurs = AlertOccur.getOrderedQuerySet().toModelArray();

  if (!alertOccurs) {
    return alertOccurs;
  }

  return alertOccurs.map((alertOccur) => ({
    ...alertOccur.ref,
    alertSetting: alertOccur.alertSetting?.ref,
    device: alertOccur.device?.ref,
    item: alertOccur.item?.ref,
    line: alertOccur.line?.ref,
    site: alertOccur.site?.ref,
  }));
});

export const alertsResSelector = createSelector(orm, ({ AlertRes }) => {
  const alertRess = AlertRes.getOrderedQuerySet().toModelArray();

  if (!alertRess) {
    return alertRess;
  }

  return alertRess.map((alertRes) => ({
    ...alertRes.ref,
    alertSetting: alertRes.alertSetting?.ref,
    device: alertRes.device?.ref,
    item: alertRes.item?.ref,
    line: alertRes.line?.ref,
    site: alertRes.site?.ref,
  }));
});

export const alertsSettingSelector = createSelector(orm, ({ AlertSetting }) => {
  const alertSettings = AlertSetting.getOrderedQuerySet().toModelArray();

  if (!alertSettings) {
    return alertSettings;
  }

  return alertSettings.map((alertSetting) => ({
    ...alertSetting.ref,
    device: alertSetting.device?.ref,
    item: alertSetting.item?.ref,
  }));
});

export const settingPriceSelector = createSelector(orm, ({ SettingPrice }) =>
  SettingPrice.getOrderedQuerySet().toRefArray(),
);

export const architectureSelector = createSelector(orm, ({ Architecture }) => {
  const architectures = Architecture.getOrderedQuerySet().toModelArray();

  if (!architectures) {
    return architectures;
  }

  return architectures.map((architecture) => ({
    ...architecture.ref,
    factory: architecture.factory?.ref,
  }));
});

export const settingEmailsSelector = createSelector(orm, ({ SettingEmail }) =>
  SettingEmail.getOrderedQuerySet().toRefArray(),
);
